import { Drawer } from "antd";
import React, { useEffect, useState } from 'react';
import Header from "../../../../components/Popup/_components/Header";
import { datetime } from "../../../../util/library/datetime";
import { useSelector } from "../../../../util/store/store";
import { propsModal } from "../../../../util/varibles/constants";
import { ISite } from "../../../../util/varibles/interface";
import SiteDetail, { TabSiteId } from "../../../LocationPage/Sites/SiteDetail";
import { selectPlan } from "../../constants";

export interface IProps {
    site: {
        id: string
        name: string
    }
    unitId?: string
    year?: number
    tab?: TabSiteId

    onUpdate?(value: ISite): void
    onClose(): void
}

const Site: React.FC<IProps> = ({
    site: { id: siteId, name: siteName },
    unitId,
    tab = TabSiteId.Analytics,
    year = datetime().year,
    onUpdate,
    onClose,
}) => {
    const [open, setOpen] = useState(true);
    const [site, setSite] = useState<ISite | undefined>();
    const sites = useSelector(selectPlan.sites);

    useEffect(() => {
        const site = sites.find(item => item.id === siteId);
        if (site) {
            setSite(site);
        }
    }, [sites, siteId, unitId]);

    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    return <Drawer
        {...propsModal}
        open={open}
        size='100%'
        title={<Header title={siteName} onClose={handleClose} />}
        onClose={handleClose}
    >
        {!!site && <SiteDetail data={site} tab={tab} year={year} unitId={unitId} onUpdate={onUpdate} />}
    </Drawer>;
};

export default Site;
